import instObj from '@/backend/axios-instances'

const resource = "/estimation"
const instance = instObj.baseInstance

export default {
  get(estimationId, parameters) {
    return instance.get(`${resource}/${estimationId}/summary`, { params: parameters });
  },
  post(estimationId, payload) {
    return instance.post(`${resource}/${estimationId}/summary`, payload);
  }
}